import React, { FC } from 'react';
import { CATEGORY_LABEL, CATEGORY_ORDER, CATEGORY_PILL } from 'util/ui';

/**
 * The storage label on a file, as a rounded pill dropdown (UI refresh, Nov 2026).
 * Green = Preview (hot storage, playable); blue = Master / Approval / Distribution (cold storage).
 * A native <select>, so it works with keyboard and screen readers and fits the row.
 */
const chevron = (color: string) =>
  `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='${encodeURIComponent(
    color,
  )}' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`;

const CategorySelect: FC<{ value: string; onChange(value: string): void; label?: string }> = ({ value, onChange, label = 'Storage label' }) => {
  const c = CATEGORY_PILL[value] || CATEGORY_PILL.master;
  return (
    <select
      aria-label={label}
      title={value === 'preview' ? 'Preview: hot storage, can be played here' : `${CATEGORY_LABEL[value] || value}: cold storage`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      style={{
        appearance: 'none',
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        width: '100%',
        maxWidth: 128,
        height: 28,
        padding: '0 26px 0 12px',
        borderRadius: 999,
        border: `1px solid ${c.border}`,
        background: `${c.bg} ${chevron(c.fg)} no-repeat right 9px center`,
        color: c.fg,
        font: 'inherit',
        fontSize: 12,
        fontWeight: 600,
        cursor: 'pointer',
      }}
    >
      {CATEGORY_ORDER.map((k) => (
        <option key={k} value={k} style={{ color: '#16181D', background: '#FFFFFF', fontWeight: 400 }}>
          {CATEGORY_LABEL[k]}
        </option>
      ))}
      {!CATEGORY_ORDER.includes(value) && <option value={value}>{value}</option>}
    </select>
  );
};

export default CategorySelect;
